import { GlobalStyles, useTheme } from "@mui/material";
import { useEffect } from "react";

function GlobalStylesMUI() {
  const theme = useTheme();

  useEffect(() => {
    // Helps native form controls, scrollbars, etc. match the mode
    document.documentElement.style.setProperty(
      "color-scheme",
      theme.palette.mode
    );
    // Optional: useful if you want [data-theme="dark"] in plain CSS
    document.documentElement.dataset.theme = theme.palette.mode;
  }, [theme.palette.mode]);

  return (
    <GlobalStyles
      styles={{
        "*": {
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", //Edge
          "&::-webkit-scrollbar": {
            display: "none", // Webkit browsers
          },
        },
        body: {
          backgroundColor: theme.palette.background.primary,
          color: theme.palette.text.primary,
          fontFamily: theme.typography.fontFamily,
        },
      }}
    />
  );
}

export default GlobalStylesMUI;
